// Copyright ©️ 2026 eVolve MEP, LLC

import type { ReactNode } from 'react';

import { Text, type TextProps } from '@mantine/core';

type Props = {
  children: ReactNode;
} & TextProps;

export const TextWithTruncate = ({ children, ...props }: Props) => (
  <Text
    {...props}
    onMouseEnter={({ currentTarget: el }) => {
      const truncated = el.scrollWidth > el.clientWidth;
      // oxlint-disable-next-line evolve/no-param-reassign
      el.title = truncated ? el.innerText : '';
    }}
    style={{
      textOverflow: 'ellipsis',
      maxWidth: '100%',
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      // TODO: `.style` can now be a function, need to handle it
      // oxlint-disable-next-line typescript/no-misused-spread
      ...props.style,
    }}
  >
    {children}
  </Text>
);
